/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { SupplierCalendarRestService } from './calendar';
import { SupplierInvoicesRestService } from './invoices';
import { SupplierOfficeRestService } from './offices';
import { SupplierUserProfileRestService } from './profiles';
import { SupplierPurchaseOrdersRestService } from './purchase-orders';
import { SupplierSharedDocsRestService } from './shared-docs';

export const DATA_SERVICES = [
  SupplierUserProfileRestService,
  SupplierOfficeRestService,
  SupplierPurchaseOrdersRestService,
  SupplierSharedDocsRestService,
  SupplierCalendarRestService,
  SupplierInvoicesRestService,
];
